import React from "react";
import "../../index.css";
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import lost10tribes from '../../Assets/Img/lost10tribes.jpg'

const Chap9 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap8">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap10">Next</Link>
      </div>

      <h1 className="chapterHeading">
        Chapter 9: The Lost 10 Tribes to Come to Zion
      </h1>

      <img src={lost10tribes} className='image' alt='Book Cover for The Quest for the Lost Ten Tribes of Israel' />

      <div className="wrapper">


      <div className="paragraph">
        <p>
          More than one century ago, in the April 1916 general conference,
          Mormon apostle James Talmage stated, “Yea, let God be true ... The
          (Lost Ten) Tribes shall come (to Zion) … they shall be brought forth
          as hath been predicted; and I say unto you there are those now living
          – aye, some here present – who shall live to read the records of the
          Lost Tribes of Israel … and those records … shall tell of the visit of
          the resurrected Christ to them, after He had manifested Himself to the
          Nephites upon this continent.”
          <btn id="clickable1" className="footnote">1 </btn>
          <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>James Talmage, April 1916 general conference.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          In the Kirtland Temple, on April 3, 1836, Joseph Smith and Oliver
          Cowdery claimed that Moses appeared to them and restored the keys to
          bring about “the gathering of Israel from the four parts of the earth”
          and the “leading of the ten tribes from the land of the north.” 
          <btn id="clickable2" className="footnote">2 </btn>
          <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>D&C 110:11.</Tooltip>
          
          An
          article of faith states, “We believe in the literal gathering of
          Israel and in the restoration of the Ten Tribes.” 
          In the Book of
          Mormon, Christ speaks of how, after leaving the Nephites, he will go
          to preach to the Lost Ten Tribes. “Now I go ... to show myself unto
          the lost tribes of Israel, for they are not lost unto the Father.”
          <btn id="clickable3" className="footnote">3 </btn>
          <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>3 Nephi 17:4.</Tooltip>

          These were essential doctrines for early Mormonism, but they are
          largely ignored today.
        </p>
      </div>

      <h2 className="headlinePadding">The Ten Tribes Taken Captive</h2>

      <div className="paragraph">
        <p>
          The Ten Tribes were taken captive by the Assyrians in 721 BCE. These
          tribes never returned to Judah but mixed with other nations and lost
          their identity. However, in Mormonism, the myth persists that the Ten
          Tribes are gathered in one location and will be led to Zion in Jackson
          County in the last days prior to the Second Coming. Joseph Smith
          revealed that John the apostle from the New Testament is with them.
          Church historian John Whitmer recorded Joseph stating in June 1831,
          “The Spirit of the Lord fell upon Joseph in an unusual manner, and he
          prophesied that John the Revelator was then among the Ten Tribes of
          Israel ... to prepare them for their return.”
          <btn id="clickable4" className="footnote">4 </btn>
          <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>History of the Church, vol. 1, p. 176.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Early Mormon Daniel Allen stated, “I heard Joseph the Prophet say that
          he had seen John the Revelator and had a long conversation with him,
          who told him that he, John, was their leader, Prophet, Priest and
          King, and said that he was preparing that people to return, and
          further said there is a mighty host to us.”
          <btn id="clickable5" className="footnote">5 </btn>
          <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Minutes of the School of the Prophets, Parawan, Utah, 1868-1872, August 17, 1872.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          The church published in October 1835, “It appears that the
          long-anticipated coming of the Ten Tribes from the north will take
          place shortly after or possibly before Zion has been sanctified.”
          <btn id="clickable6" className="footnote">6 </btn>
          <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Messenger and Advocate, Vol II, October 1835.</Tooltip>

          Oliver Cowdery stated that the Angel Moroni instructed Joseph that
          “after the Church shall be sanctified and receive an inheritance … the
          Ten Tribes of Israel will be revealed in the north country whither
          they have been for a long season.”
          <btn id="clickable7" className="footnote">7 </btn>
          <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>Messenger and Advocate, Vol II, October 1835.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Joseph revealed, “And they who are in the north countries shall come
          in remembrance before the Lord; and their prophets shall hear his
          voice … and they shall smite the rocks, and the ice shall flow down at
          their presence. And an highway shall be cast up in the midst of the
          great deep.” 
          <btn id="clickable8" className="footnote">8 </btn>
          <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>D&C 133:26-27.</Tooltip>
          
          Therefore, the ice of the polar region will flow down at
          their presence. A highway will be cast up in the midst of the great
          deep – the ocean. Joseph also revealed that when the Lost 10 Tribes
          arrive in Jackson County, they shall, “… fall down and be crowned with
          glory, even in Zion, by the hands of the servants of the Lord, even
          the children of Ephraim. And they shall be filled with songs of
          everlasting joy.”
          <btn id="clickable9" className="footnote">9 </btn>
          <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>D&C 133:32-33.</Tooltip>
        </p>
      </div>

      <h2 className="headlinePadding">Where are the Lost Ten Tribes Now?</h2>

      <div className="paragraph">
        <p>
          So where are the Lost Ten Tribes now? Sixth Mormon prophet Joseph F.
          Smith taught, “The Ten Tribes were taken by force out of the land …
          Many of them mixed with the peoples among whom they were scattered. A
          large portion, however, departed in one body to the north, and
          disappeared from the rest of the world … that they will return in a
          body, must be believed, else how shall the scriptures be fulfilled?”
              <btn id="clickable10" className="footnote">10 </btn>
        <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>Joseph F. Smith, The Way to Perfection, 1940.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Regarding the Lost Ten Tribes’ location in the north, in a letter from
          W.W. Phelps to Oliver Cowdery, Phelps suggests that there may be a
          “continent at the North Pole, of more than 1,300 square miles,
          containing thousands of millions of Israelites, who, after a highway
          is cast up in the great deep, may come to Zion, singing songs of
          everlasting joy.”
          <btn id="clickable11" className="footnote">11 </btn>
          <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Letter No. 11. W. W. Phelps to Oliver Cowdery. Latter Day Saints’ Messenger and Advocate (Kirtland) 2, no. 1 (October 1835): 193–95.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Early Mormon Benjamin Johnson remarked about the Lost Ten Tribes being
          in the North Pole, “Sometimes when at my house I asked him (Joseph)
          questions … I asked where the nine and a half tribes of Israel were.
          ‘Well,’ said he, ‘you remember the old caldron or potash kettle you
          used to boil maple sap in for sugar, don’t you?’ I said yes. ‘Well,’
          said he, ‘they are in the north pole in a concave just the shape of
          that kettle. And John the Revelator is with them, preparing them for
          their return.” 
          <btn id="clickable12" className="footnote">12 </btn>
          <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Benjamin Johnson, My Life's Review, 1947, p. 93.</Tooltip>
          
          Early Mormon Oliver Huntington commented about the Lost
          Ten Tribes being in the North Pole, “I have heard Joseph say that John
          was among the Ten Tribes beyond the North Pole.”
          <btn id="clickable13" className="footnote">13 </btn>
          <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Oliver B. Huntington Journal, under January 13, 1881; see Abanes, One Nation Under Gods, p. 528, footnote 100.</Tooltip>
        </p>
      </div>

      <h2 className="headlinePadding">Joseph Teaches Ten Tribes are Not on the Earth</h2>

      <div className="paragraph">
        <p>
          Bathsheba Smith published in the church’s Juvenile Instructor, “I
          heard him (Joseph) say ‘Peradventure, the Ten Tribes were not on this
          globe, but a portion of this earth cleaved off with them, went flying
          into space, and when the earth reels to and fro like a drunken man and
          the stars from heaven fall (referring the Second Coming), it would
          join on again.’” 
          <btn id="clickable14" className="footnote">14 </btn>
          <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Bathsheba W. Smith, Juvenile Instructor, June 1, 1892, Vol. 27, page 344, Recollections of the Prophet Joseph Smith. </Tooltip>
          
          According to Mormon apostle Orson Pratt, “The Prophet
          Joseph once in my hearing advanced his opinion that the Ten Tribes
          were separated from the Earth; or a portion of the Earth was by a
          miracle broken off, and that the Ten Tribes were taken away with it,
          and that in the latter days it would be restored to the Earth or be
          let down in the Polar regions.”
          <btn id="clickable15" className="footnote">15 </btn>
          <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Orson Pratt, Letter Box of Orson Pratt, LDS Church Historian's Office, letter to John C. Hall, December 13, 1875; see Abanes, One Nation Under Gods, p. 529, footnote 101.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Brigham Young taught, “It is no more difficult to transfer the Ten
          Tribes from this earth to another planet, than it is to take the city
          of Enoch from this earth or bring Adam and Eve from another planet.”
          <btn id="clickable16" className="footnote">16 </btn>
          <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Brigham Young, Journal of Discourses, October 9, 1859, Volume 7, 285-286.</Tooltip>

          According to Wilford Woodruff, “President Young said he heard Joseph
          Smith say that the Ten Tribes of Israel were on a Portion of Land
          separated from this Earth.” 
          <btn id="clickable17" className="footnote">17 </btn>
          <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>Wilford Woodruff's Journal, September 8, 1867, reprinted in Susan Staker, ed., Waiting for World's End, The Diaries of Wilford Woodruff, 1993, p. 291.</Tooltip>
          
          Also from Wilford, “The evening was spent
          in conversing upon the subject of the Ten tribes in the North Country
          … a portion of the north country containing the ten tribes may be
          separated from the Earth. Orson Hyde & others believed they would soon
          return.”
          <btn id="clickable18" className="footnote">18 </btn>
          <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Wilford Woodruff's Journal, September 8, 1867, reprinted in Susan Staker, ed., Waiting for World's End, The Diaries of Wilford Woodruff, 1993, p. 238.</Tooltip>
        </p>
      </div>

      <h2 className="headlinePadding">Interview of Homer Brown</h2>

      <div className="paragraph">
        <p>
          Early Mormon Homer Brown
          <btn id="clickable19" className="footnote">19 </btn>
          <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>Interview of Homer Brown of the Forest Dale ward, Granite Stake, grandson of Benjamin Brown answered these questions. “Brother Brown, can you give us some light and explanation of the fifth verse, page 386, of the Hymn Book, (HYMN No. 323, ENOCH, little pocket Hymn Book 1905), which speaks of the Ten Tribes of Israel on part of the earth which now forms another planet, according to the composer, Eliza R. Snow?” “Yes, sir, I think I can – I think I can answer that question. Sister Eliza R. Snow, when visiting my grandparents, was asked by my grandmother: ‘Eliza, where did you get your idea about the Ten Lost Tribes being taken as you explained in your hymn on page 386 of the Hymn Book?’ She answered as follows, ‘Why, my husband, the Prophet Joseph told me about it.’”</Tooltip>
          
           was interviewed about an experience he and
          his wife had with Eliza Snow, a plural wife of Joseph Smith. He asked
          Eliza about a hymn she had written. In the interview Homer was asked,
          “Brother Brown, can you give us some light and explanation of the
          fifth verse, page 386, of the Hymn Book, which speaks of the Ten
          Tribes of Israel on part of the earth which now forms another planet,
          according to the composer, Eliza R. Snow?”
        </p>
      </div>

      <div className="paragraph">
        <p>
          “... ‘Eliza, where did you get your idea about the Ten Lost Tribes
          being taken as you explained in your hymn on page 386 of the Hymn
          Book?’ 
          <btn id="clickable20" className="footnote">20 </btn>
          <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>HYMN No. 323, ENOCH, little pocket Hymn Book 1905.</Tooltip>
          
          She answered as follows, ‘Why, my husband, the Prophet Joseph
          told me about it.’”
        </p>
      </div>

      <div className="paragraph">
        <p>
          “Have you any other information, Brother Brown, that your grandfather
          ever gave you as contained in any conversation with the Prophet
          Joseph?”
        </p>
      </div>

      <div className="paragraph">
        <p>
          “Yes, I have. One evening in Nauvoo, just after dark, somebody rapped
          at my grandfather’s door … There he met the Prophet Joseph Smith who
          said, ‘Brother Brown, can you keep me over night? The mobs are after
          me.’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “Grandfather answered, ‘Yes sir. It will not be the first time. Come
          in.’”
        </p>
      </div>

      <div className="paragraph">
        <p>
          “‘All right, ‘said the Prophet, shutting the door quickly. He came in
          and sat down.”
        </p>
      </div>

      <div className="paragraph">
        <p>“Grandmother said, ‘Brother Joseph, have you had your supper?’</p>
      </div>

      <div className="paragraph">
        <p>
          “‘No,’ he answered, ‘I have not.’ So, she prepared a meal for him, and
          he ate it.”
        </p>
      </div>

      <div className="paragraph">
        <p>
          “Afterwards, they conversed relative to the principles of the Gospel,
          and during the conversation the Ten Tribes were mentioned. Grandfather
          said, where are the Ten Tribes?’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “He [Joseph] answered, come to the door and I will show you. Come on,
          Sister Brown, I want you both to see.’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “It being a starlight night, the Prophet said, ‘Brother Brown, can you
          show me the Polar Star?’
        </p>
      </div>

      <div className="paragraph">
        <p>“Yes sir,’ he said, pointing to the North Star. ‘There it is.’</p>
      </div>

      <div className="paragraph">
        <p>“‘Yes, I know, ‘said the Prophet, ‘but which one?’</p>
      </div>

      <div className="paragraph">
        <p>
          “Then grandfather said, ‘Can you see the points of the Great Dipper?’
        </p>
      </div>

      <div className="paragraph">
        <p>“The Prophet said, ‘Yes.’</p>
      </div>

      <div className="paragraph">
        <p>
          “‘Well, trace the pointers pointing up to the largest star. That is
          the North Star’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “‘You are correct,’ the Prophet replied. ‘Now, do you discern a little
          twinkler to the right and below the Polar Star, which appears to be
          about 20 feet apart from here?’
        </p>
      </div>

      <div className="paragraph">
        <p>“Grandfather answered, ‘Yes, sir.’</p>
      </div>

      <div className="paragraph">
        <p>The Prophet said, ‘Sister Brown, do you see that star also?’</p>
      </div>

      <div className="paragraph">
        <p>“She answered, ‘Yes, sir.’</p>
      </div>

      <div className="paragraph">
        <p>
          “After entering the house, the Prophet said, ‘Brother Brown, I noticed
          when I came in that you were reading the Doctrine and Covenants. Will
          you kindly get it?’ He did so, and the Prophet turned to what is now
          the 133rd Section, and commencing at the 26th verse, read to the 34th
          verse.”
        </p>
      </div>

      <div className="paragraph">
        <p>
          26. And they who are in the north countries shall come in remembrance
          before the Lord; and their prophets shall hear his voice and shall no
          longer stay themselves; and they shall smite the rocks, and the ice
          shall flow down at their presence.
        </p>
        <p>
          27. And a highway shall be cast up in the midst of the great deep.
        </p>
        <p>28. Their enemies shall become a prey unto them,</p>
        <p>
          29. And in the barren deserts there shall come forth pools of living
          water; and the parched ground shall no longer be a thirsty land.
        </p>
        <p>
          30. And they shall bring forth their rich treasures unto the children
          of Ephraim, my servants.
        </p>
        <p>
          31. And the boundaries of the everlasting hills shall tremble at their
          presence.
        </p>
      </div>

      <div className="paragraph">
        <p>
          “After reading the 31st verse, he said, ‘Now let me ask you: What
          would cause the everlasting hills to tremble with more violence than
          the coming together of the two planets? That planet on which they
          reside will return to this earth!’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “‘Now what would cause the mountains of ice to melt quicker than the
          heat caused by the friction of two planets coming together? Did you
          ever see a meteor that was not red hot? So, you see, that would cause
          the mountains of ice to melt.’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “‘And relative to the Great Highway that should be cast up; when that
          planet returns to its place in the great northern waters, it will form
          a highway, and the waters will recede and roll back. Now, as to their
          coming back from the northern waters,’ he continued, ‘they will return
          from the North, because this planet will return from the northern
          place from whence it was taken.
        </p>
      </div>

      <div className="paragraph">
        <p>
          “‘Relative to the waters rolling back to the North: If you take a
          vessel of water and swing it rapidly around your head, you won’t spill
          any. But if you stop the motion gradually, it will begin to pour out.
          Now, Brother Brown, at the present time this earth is rotating very
          rapidly. When this planet returns, it will make the earth that much
          heavier, and it will revolve slower, which will cause the waters to
          continue eastward rapidly.’”
        </p>
      </div>

      <div className="paragraph">
        <p>
          Then, Joseph discussed the City of Enoch. “Did the Prophet ever tell
          your grandfather about the City of Enoch being taken from the earth?”
          “Yes, he did. He said that Enoch and his people kept so faithfully the
          laws of the Lord that they were translated. Not only Enoch and his
          people, but the Great City wherein they dwelt. Grandfather asked the
          Prophet, ‘Brother Joseph where was the City of Enoch located?’”
        </p>
      </div>

      <div className="paragraph">
        <p>
          “The Prophet answered, ‘Where the Gulf of Mexico now is.’ And he said,
          ‘The time will come when the mariner will say there is no bottom to
          the Gulf of Mexico. When that great piece of land was taken from the
          earth, it created a vacuum to the extent that it started a current
          that is now known as the Gulf Stream.’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “‘Then he [Joseph] added, ‘In consequence of this great portion being
          taken away, it naturally threw the earth out of balance. Now when it
          comes back, and also the planet on which the Lost Tribes are, the
          earth will receive its equilibrium and revolve as it naturally was in
          the very beginning.’
        </p>
      </div>

      <div className="paragraph">
        <p>
          “‘Then, Brother Brown, this will fulfill the saying of the Prophet
          Jeremiah, chapter 16:14-15, “Therefore a day cometh, saith the Lord,
          that it shall no more be said, The Lord liveth, that brought up the
          children of Israel from the land of the north, and from the lands
          whither he had driven them; and I will bring them again unto their
          land that I gave unto their fathers.” Also, the saying of the Prophet
          Nephi: And it shall come to pass that the Jews shall have the words of
          the Nephites, and the Nephites shall have the words of the Jews; and
          the Nephites and the Jews shall have the words of the Lost Tribes of
          Israel shall have the words of the Nephites and the Jews.’”
        </p>
      </div>

      <h2 className="headlinePadding">Return from the North Country</h2>

      <div className="paragraph">
        <p>
          From these statements, Joseph taught that the Lost Ten Tribes are
          residing in space on a portion of Earth. As part of the events leading
          to the Second Coming, that portion of earth will be returned to this
          earth near the north pole. When the portion of earth comes in contact
          with the polar region, the heat created from entering the earth’s
          atmosphere will be so great it will melt the ice, and a great highway
          will emerge. Then, a resurrected Joseph Smith, along with John the
          Revelator, will lead the Lost Ten Tribes to Zion in Jackson County.
        </p>
      </div>

      <div className="paragraph">
        <p>
          We learn this from Oliver Cowdery in his patriarchal blessing to
          Joseph. “[Joseph Smith] will go forth toward the north, and by the
          power of his word shall the deep begin to give way: and the ice melt
          before the Sun. By the keys of the kingdom shall he lead Israel into
          the land of Zion, while the house of Jacob shouts in the dance and in
          the song.”
          <btn id="clickable21" className="footnote">21 </btn>
          <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>A Patriarchal blessing given by Oliver Cowdery to Joseph Smith at Kirtland, September 22, 1835, reprinted in Collier, ed., Unpublished Revelations, 1979, 2nd edition, 1981, vol. 1, p. 76.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Regarding the return of the Lost Ten Tribes, the church published in
          the Millennial Star in February 1841 quoting the Book of Revelation
          and then providing commentary. “Revelation 6:13 – And the stars of
          heaven shall fall unto the earth, even as a fig tree casteth her
          untimely figs, when she is shaken of a mighty wind. “Response: How can
          the stars fall from heaven to the earth when they (as far as we know)
          are much larger than the earth? We are not here given to understand
          that all the stars will fall, or even many of them: but only as a fig
          tree casteth her untimely figs when she is shaken by the wind. The
          stars which will fall to the earth are fragments which have been
          broken off from the earth from time to time in the mighty convulsions
          of nature; some in the days of Enoch; some in the days of Peleg; some
          with the Ten Tribes; and some with the death of Christ. These must all
          be restored again at the time of the restitution of all things. This
          will restore the Ten Tribes of Israel.”
          <btn id="clickable22" className="footnote">22 </btn>
          <Tooltip anchorSelect="#clickable22" className="footnote-size" clickable>Millennial Star, vol. 1, no. 10, Parley Pratt in answer to questions from Joseph Fielding.</Tooltip>

        </p>
      </div>

      <div className="paragraph">
        <p>
          Therefore, the Ten Tribes were taken into space as a portion of the
          Earth was broken off. When they return, that portion will touch down
          near the north pole just prior to the Second Coming. This event will
          create the heat necessary to melt the polar ice caps, and the Lost Ten
          Tribes will walk to Jackson County with Joseph Smith and John the
          Revelator. Regarding Joseph’s teaching that the Lost Ten Tribes reside
          on a portion of the earth in space, the Mormon apologists will say
          this is just Joseph theorizing. Maybe so. But he left many of his
          followers with the impression that this was true speaking as a
          prophet.
        </p>
      </div>

      </div>

      <div className="chapterFooter">
        <Link to="/Chap8">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap10">Next</Link>
      </div>
      
    </div>
  );
};

export default Chap9;
